/* src/app/forms/produtos/amazon/new-product-amazon/new-product-amazon.component.scss */
.foto {
  width: 100%;
  display: flex;
  justify-content: center;
}
.dados {
  margin: 20px;
  flex-grow: 3;
  overflow: auto;
}
.title {
  font-weight: 500;
  text-align: left;
}
.sumario {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.link-more {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
.sumario .left {
  padding: 6px;
  float: left;
  width: 50%;
}
.sumario .right {
  padding: 6px;
  float: right;
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.content {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 150px;
  max-height: 150px;
  overflow: auto;
}
.mat-mdc-card-title {
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.mat-mdc-card-subtitle {
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=new-product-amazon.component.css.map */
